import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import css from './AuthBox.module.scss';
import { AuthHero } from './AuthHero';
import { Logo } from './Logo';

export const AuthBox = ({
  children,
  variant,
}: {
  children: React.ReactNode;
  variant?: 'login' | 'register';
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [heroWidth, setHeroWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.getBoundingClientRect().width;
        setHeroWidth(Math.floor((containerWidth * 56) / 100));
      }
    };

    // Initial calculation
    updateWidth();

    // Create ResizeObserver for more reliable size updates
    const resizeObserver = new ResizeObserver(updateWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Box className={css.authBoxContainer} ref={containerRef}>
      <Box className={css.text}>
        <Box className={css.textInner}>
          <Box className={variant == 'login' ? css.loginBoxContainer : css.nonLoginBoxContainer}>
            <Logo />
            {children}
          </Box>
        </Box>
      </Box>
      <Box className={css.hero}>
        <AuthHero width={heroWidth} />
      </Box>
    </Box>
  );
};
